// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"31ae0759","173":"ffaa0384","236":"aeb890d9","430":"5319b32f","478":"30d33a1a","491":"b8b32103"}[chunkId] + ".chunk.js";
};